import { Environment } from '../enums/environment';

const APP_TITLE: string = 'ShipIT';

const setAppTitle = (environment: Environment): void => {
    document.title = environment === Environment.PROD ? APP_TITLE : `${APP_TITLE} (${environment})`;
};

export { setAppTitle };
